import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'
import { MESSAGES } from '../constants'

const deleteMessage = async (id: number) => {
  await fetchAPI({
    path: `/messages/${id}`,
    method: 'delete',
  })
}

export const useDeleteMessage = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(deleteMessage, {
    async onSuccess() {
      await queryClient.refetchQueries([MESSAGES])

      toast({
        description: t('views.admin.messages.services.delete_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
